// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602031203/js/" + chunkId + "." + {"44":"7d5e3528","225":"798c51b3","481":"eb71f645","486":"ffa825f2","770":"e09df82d"}[chunkId] + ".0.43675193430477566.chunk.js";
};